module.exports = __webpack_public_path__ + "img/cb234d2c5e8957e44cd121b4e57bfb6e.bcad4946.jpg";